import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, CreditCard } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800" data-testid="footer">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <div className="relative h-20">
                <img 
                  src="https://customer-assets.emergentagent.com/job_nbtx-painters/artifacts/lqy9nqx4_ProPainitngLoGo-removebg-preview.png" 
                  alt="Pro Painting - 25 Years of Excellence - South Texas"
                  className="h-full w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Professional residential painting services backed by 25+ years of experience. Quality craftsmanship, detailed proposals, and exceptional results.
            </p>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="font-heading font-bold text-lg text-white uppercase tracking-wider mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+18303270136"
                  className="flex items-start gap-3 text-slate-400 hover:text-amber-500 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>(830) 327-0136</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:matthew@propainting.cloud"
                  className="flex items-start gap-3 text-slate-400 hover:text-amber-500 transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>matthew@propainting.cloud</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>493 N Market St<br />New Braunfels, TX 78130</span>
              </li>
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading font-bold text-lg text-white uppercase tracking-wider mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-amber-500 transition-colors text-sm" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/free-strategy-call" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  Free Strategy Call
                </Link>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61583573996819"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                >
                  Facebook
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61583573996819"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-amber-500 hover:border-amber-500/50 transition-all mt-2"
                  data-testid="footer-facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Payment */}
          <div>
            <h4 className="font-heading font-bold text-lg text-white uppercase tracking-wider mb-6">Legal & Payment</h4>
            <ul className="space-y-3 mb-6">
              <li>
                <Link to="/privacy-225682" className="text-slate-400 hover:text-amber-500 transition-colors text-sm" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-amber-500 transition-colors text-sm" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/sms-terms" className="text-slate-400 hover:text-amber-500 transition-colors text-sm" data-testid="footer-sms-terms-link">
                  SMS Terms
                </Link>
              </li>
            </ul>
            
            {/* Pay Invoice Button */}
            <div className="pt-4 border-t border-slate-800">
              <a
                href="#stripe-payment-link"
                className="inline-flex items-center gap-2 bg-slate-900 border border-slate-700 hover:border-amber-500/50 text-slate-300 hover:text-amber-500 px-4 py-2 text-sm uppercase tracking-wider transition-all"
                data-testid="footer-pay-invoice"
              >
                <CreditCard className="w-4 h-4" />
                Pay Invoice
              </a>
              <p className="text-xs text-slate-600 mt-2">Payments processed securely via Stripe</p>
              <p className="text-xs text-slate-500 mt-1 italic">
                {/* ADMIN NOTE: Replace href="#stripe-payment-link" with your Stripe payment link */}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>&copy; {currentYear} Pro Painting. All rights reserved.</p>
            <p>Serving New Braunfels & Surrounding Areas</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
